import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, IconWrap, SubmitButton } from './styles';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { PromoIcon } from '../common/promo-icon/PromoIcon';

const PromoPopupButton = (props) => {
    return (
        <>
            {props.type !== 'submit' && (
                <CommonButton
                    href={props.href ? props.href : null}
                    rel={props.rel ? props.rel : null}
                    title={props.title ? props.title : null}
                    target={props.target ? props.target : null}
                    id={props.id ? props.id : null}
                    data-testid={props.dataTestId ? props.dataTestId : null}
                    isAlertButton={props.isAlertButton}
                    onClick={(e) => {
                        if (props.onClick) {
                            props.onClick(e);
                        }
                    }}
                >
                    <IconWrap>
                        <PromoIcon name={props.iconName} color={props.isAlertButton ? 'error' : 'primary'} size="24px" />
                    </IconWrap>
                    <LightText ellipsis color={props.isAlertButton ? 'red' : 'purple'}>
                        {props.text}
                    </LightText>
                </CommonButton>
            )}
            {props.type === 'submit' && (
                <SubmitButton
                    id={props.id ? props.id : null}
                    type={props.type}
                    tabIndex={props.tabIndex}
                    form={props.buttonForm ? props.buttonForm : null}
                    isAlertButton={props.isAlertButton}
                    value={props.value}
                    onClick={(e) => {
                        if (props.onClick) {
                            props.onClick(e);
                        }
                    }}
                >
                    <IconWrap>
                        <PromoIcon name={props.iconName} color={props.isAlertButton ? 'error' : 'primary'} size="24px" />
                    </IconWrap>
                    <LightText ellipsis color={props.isAlertButton ? 'red' : 'purple'}>
                        {props.text}
                    </LightText>
                </SubmitButton>
            )}
        </>
    );
};
export default PromoPopupButton;

PromoPopupButton.propTypes = {
    type: PropTypes.string,
    href: PropTypes.string,
    rel: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
    id: PropTypes.string,
    dataTestId: PropTypes.string,
    isAlertButton: PropTypes.bool,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    text: PropTypes.string,
    tabIndex: PropTypes.string,
    value: PropTypes.string,
    buttonForm: PropTypes.string,
};
